<template>
    <div class="container">
        <div class="row justify-content-md-center">
            <div class="col-md-10">
                <h1 class="mt-5 mb-5">Características de la app</h1>
                <div class="row mb-10 mb-5 align-items-center">
                    <div class="col-md-6 d-sm-none d-block mb-5 mb-md-0">
                        <img :src="require('../assets/images/phone.png')" class="img-fluid">
                    </div>
                    <div class="col-md-6">
                        <h4 class="mb-3">Contenido multimedia</h4>
                        <p>Más de 3000 cursos sobre el Talmud en audio, video y texto que se actualizan cada semana. Puedes descargar los cursos para escucharlas cuando quieras, incluso sin conexión a Internet.</p>
                    </div>
                    <div class="col-md-6 d-none d-sm-block">
                        <img :src="require('../assets/images/phone.png')" class="img-fluid">
                    </div>
                </div>
                <div class="row mb-10 mb-5 align-items-center">
                    <div class="col-md-6 mb-5 mb-md-0">
                        <img :src="require('../assets/images/controls.png')" class="img-fluid">
                    </div>
                    <div class="col-md-6">
                        <h4 class="mb-3">Diseña tu propio plan de estudios</h4>
                        <p>Elige los temas que más despierten tu interés y diseña tu propio plan de estudio para disfrutar del Talmud a tu ritmo y sin estrés. Además, puedes contactar con nosotros para acceder a programas de estudio especiales que incluyen clases en vivo y contenidos exclusivos.</p>
                    </div>
                </div>
                <div class="row mb-10 mb-5 align-items-center">
                    <div class="col-md-6 d-sm-none d-block mb-5 mb-md-0">
                        <img :src="require('../assets/images/accessible.png')" class="img-fluid">
                    </div>
                    <div class="col-md-6">
                        <h4 class="mb-3">Calidad y accesibilidad</h4>
                        <p>Nuestros cursos están impartidos por Talmidé Jajamim de contrastada experiencia y pasan por un exhaustivo proceso de corrección y edición que garantiza su calidad. Además, están disponibles en formato texto, audio y video para asegurar su accesibilidad las 24 h.</p>
                    </div>
                    <div class="col-md-6 d-sm-block d-none">
                        <img :src="require('../assets/images/accessible.png')" class="img-fluid">
                    </div>
                </div>
                <div class="row mb-10 mb-5 align-items-center">
                    <div class="col-md-6 mb-5 mb-md-0">
                        <img :src="require('../assets/images/gratitude.png')" class="img-fluid">
                    </div>
                    <div class="col-md-6">
                        <h4 class="mb-3">Expresa tu gratitud</h4>
                        <p>En Jabrutouch, para estudiar Talmud solo tienes que dar las gracias. Cada <i>shiur</i> es un regalo que te hace llegar otro <i>yehudí</i> gracias a nuestro sistema de <i>ketarim</i>, una moneda creada para regalar shiurim entre nosotros. Así, cada clase que estudies estará enfundada de <i>Jesed</i> y gratitud. </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>
<style lang="scss">

</style>